type MentionUser = { id: number; name: string };

export const resolveUserMentions = (
	text: string,
	users: MentionUser[],
	format: (name: string) => string = name => `@${name}`
): string =>
	text.replace(/@__user\$(\d+)__/g, (tag, id) => {
		const user = users.find(u => u.id === parseInt(id, 10));
		return user ? format(user.name) : tag;
	});
